import type { GiftPassDetail } from '../../api/gift-passes';
import { usePermissions } from '../../hooks/usePermissions';
import { Permission } from '../../types/permissions';

import { availableGiftPassActions, type AvailableGiftPassActions } from './gift-pass-actions-model';

export function useGiftPassActions(pass: GiftPassDetail): AvailableGiftPassActions {
  const { hasPermission } = usePermissions();
  return availableGiftPassActions(pass, {
    void: hasPermission(Permission.VOID_GIFT_PASSES),
    resend: hasPermission(Permission.RESEND_GIFT_PASSES),
  });
}
